var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1663 6.10044C12.6263 3.68044 10.373 2.28711 7.99967 2.28711C6.81301 2.28711 5.65967 2.63378 4.60634 3.28044C3.55301 3.93378 2.60634 4.88711 1.83301 6.10044C1.16634 7.14711 1.16634 8.84711 1.83301 9.89378C3.37301 12.3204 5.62634 13.7071 7.99967 13.7071C9.18634 13.7071 10.3397 13.3604 11.393 12.7138C12.4463 12.0604 13.393 11.1071 14.1663 9.89378C14.833 8.85378 14.833 7.14711 14.1663 6.10044ZM7.99967 10.6938C6.50634 10.6938 5.30634 9.48711 5.30634 8.00044C5.30634 6.51378 6.50634 5.30711 7.99967 5.30711C9.49301 5.30711 10.693 6.51378 10.693 8.00044C10.693 9.48711 9.49301 10.6938 7.99967 10.6938Z",
    fill: "#000014"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99961 6.09375C6.95294 6.09375 6.09961 6.94708 6.09961 8.00042C6.09961 9.04708 6.95294 9.90042 7.99961 9.90042C9.04628 9.90042 9.90628 9.04708 9.90628 8.00042C9.90628 6.95375 9.04628 6.09375 7.99961 6.09375Z",
    fill: "#000014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallEye);
export default __webpack_public_path__ + "static/media/smallEye.c8a3e36ec5f049c9ef9898ae012c5d8b.svg";
export { ForwardRef as ReactComponent };